/**
 * Signature envelope mocks — Step 7 (sales contract) and Step 23 (invoice).
 *
 * Mirrors a DocuSign / HelloSign envelope shape:
 *   - title, doc filename, signers, status, sent/completed timestamps
 */

const isoDaysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString();
};

export const SIGNATURES = {
  'demo-radios': [],

  'demo-furniture': [
    {
      id: 's1',
      title: 'Sales contract — Modular ergonomic workstations',
      docName: 'sales-contract-ergomax-W8475-final.pdf',
      status: 'completed',
      sentAt: isoDaysAgo(19),
      completedAt: isoDaysAgo(18),
      signers: [
        { name: 'B. Holden', role: 'Buyer (You)', email: 'b.holden@aiquire.ca', status: 'signed', signedAt: isoDaysAgo(19) },
        { name: 'Wei Zhang', role: 'Seller (ErgoMax)', email: 'wei@ergomax.cn', status: 'signed', signedAt: isoDaysAgo(18) },
      ],
    },
  ],

  'demo-streetlights': [
    {
      id: 's1',
      title: 'Sales contract — LED streetlights, 1100 units',
      docName: 'sales-contract-brightway-EN578-final.pdf',
      status: 'completed',
      sentAt: isoDaysAgo(46),
      completedAt: isoDaysAgo(45),
      signers: [
        { name: 'B. Holden', role: 'Buyer (You)', email: 'b.holden@aiquire.ca', status: 'signed', signedAt: isoDaysAgo(46) },
        { name: 'Li Wei',    role: 'Seller (Brightway)', email: 'li@brightway-led.com', status: 'signed', signedAt: isoDaysAgo(45) },
      ],
    },
    {
      id: 's2',
      title: 'Government invoice — INV-2026-0142',
      docName: 'invoice-INV-2026-0142.pdf',
      status: 'pending',
      sentAt: isoDaysAgo(0),
      completedAt: null,
      signers: [
        { name: 'B. Holden', role: 'Issuer (You)',     email: 'b.holden@aiquire.ca',                   status: 'signed', signedAt: isoDaysAgo(0) },
        { name: 'M. Beaulieu', role: 'PSPC Approver',  email: 'marie.beaulieu@tpsgc-pwgsc.gc.ca',     status: 'pending', signedAt: null },
      ],
    },
  ],
};
